import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 引入路由
import "@/assets/styles/index.scss"; // global css
// 在 Vue 3 中，使用 createApp 创建的实例，不再有 Vue.use 方法，需要使用 app.use 
import { createMetaManager } from 'vue-meta'; 

const app = createApp(App);
const metaManager = createMetaManager();
app.use(metaManager); 
app.use(router); // 使用路由
app.mount('#app');
